import axios from ".";
import { getAuthToken } from "../common/routines/user-operations";
const token = getAuthToken();

export const getTenantProfile = (params?: { id: string | number }) => {
  return axios({
    method: "GET",
    url: `/settings/tenant/${params?.id}`,
    params: {},
  });
};

export const updateProfileDetails = (
  tenantId: number,
  section: string,
  data: {},
) => {
  return axios({
    method: "PUT",
    url: `/settings/tenant/${tenantId}/update/${section}`,
    data,
  });
};

export const updateProfileUsers = (id: number, data: any) => {
  return axios({
    method: "PUT",
    url: `/settings/tenant/${id}/users`,
    data,
  });
};

export const updateTenantUsers = (
  id: number,
  data: any,
  moduleName?: string,
) => {
  return axios({
    method: "PUT",
    url: `users/tenant/${id}/update-user`,
    data,
    headers: {
      "x-source-module": moduleName,
    },
  });
};

export const deleteTenantUsers = (id: number, data: any) => {
  return axios({
    method: "DELETE",
    url: `users/tenant/${id}/delete-user`,
    data,
  });
};

export const getTenantPlanDetails = () => {
  return axios({
    method: "GET",
    url: `/settings/my-plans`,
  });
};

export const updateTenantPlanDetails = (data: any) => {
  return axios({
    method: "POST",
    url: `/settings/upgrade-plan-request`,
    data,
  });
};

export const downgradeTenantPlanDetails = (data: any) => {
  return axios({
    method: "POST",
    url: `/settings/downgrade-plan-request`,
    data,
  });
};

export const getUserDetails = (userId?: number, params?: any) => {
  return axios({
    method: "GET",
    url: `/settings/user/${userId}`,
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const uploadUserProfileImage = (data: any) => {
  return axios({
    method: "POST",
    url: `/settings/user/upload-user-profile`,
    data,
  });
};

export const updateUserProfile = (data: any) => {
  return axios({
    method: "PUT",
    url: `/settings/user/update-user-profile`,
    data,
  });
};

export const getEmailServiceOptions = () => {
  return axios({
    method: "GET",
    url: `/settings/email-service-options`,
  });
};

export const getUploadTrackingRecords = (params?: any) => {
  return axios({
    method: "GET",
    url: `/settings/track-file-uploads`,
    params,
  });
};

export const getUsersWhoUploadedFiles = (params?: any) => {
  return axios({
    method: "GET",
    url: `/settings/file-uploaded-users`,
    params,
  });
};

export const getModulesWithUploadTracking = () => {
  return axios({
    method: "GET",
    url: `/settings/modules-with-file-uploads`,
  });
};

export const getSelfLinkedPartnerStatus = (tenantId: number) => {
  return axios({
    method: "GET",
    url: `/settings/tenant/${tenantId}/linked-partner-status`,
  });
};

export const selfLinkWithPartner = (tenantId: number, data: any) => {
  return axios({
    method: "POST",
    url: `/settings/tenant/${tenantId}/link-partner`,
    data,
  });
};
